import { DateField, FormActions } from '@common';
import { zodResolver } from '@hookform/resolvers/zod';
import { Modal, ModalProps, Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useVersionFormSchema, VersionFormDataType } from './hooks';

const TRANS_KEY = 'VERSION_SELECT.EDIT_VERSION_MODAL';

type VersionFormModalPropsType = ModalProps & {
  defaultVersionValue?: string;
  onSave: (data: VersionFormDataType) => Promise<void>;
};

export const VersionFormModal: React.FC<VersionFormModalPropsType> = ({
  defaultVersionValue,
  onSave,
  ...props
}) => {
  const { t } = useTranslation();
  const { schema, defaultValues } = useVersionFormSchema(
    defaultVersionValue ?? ''
  );

  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSave = async (data: VersionFormDataType) => {
    await onSave(data);
    props.onClose();
  };

  return (
    <Modal {...props} title={t(`${TRANS_KEY}.TITLE`)}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSave)}>
          <Stack>
            <DateField<VersionFormDataType>
              fieldName="version"
              label={t(`${TRANS_KEY}.VERSION_LABEL`)}
              placeholder={t(`${TRANS_KEY}.VERSION_PLACEHOLDER`)}
            />
            <FormActions
              onCancel={props.onClose}
              saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
              cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
            />
          </Stack>
        </form>
      </FormProvider>
    </Modal>
  );
};
